import { createFileRoute, redirect } from '@tanstack/react-router';

// AB#594: Billing moved under the Account section. Keep the old path alive for
// bookmarks/deep links by redirecting to its new home.
export const Route = createFileRoute('/billing')({
  beforeLoad: () => {
    throw redirect({ to: '/account/billing', replace: true });
  },
});
